/**
 * @file WrongPasscode.tsx
 * @description
 * Simple page component displayed when a user enters an incorrect passcode.
 * Provides a message and a link to return to the login page.
 *
 * @dependencies
 * - react-router-dom: For navigation link.
 */

import React from 'react';
import { Link } from 'react-router-dom';

const WrongPasscode: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100">
      <h1 className="text-4xl font-bold mb-4">Access Denied</h1>
      <p className="text-lg mb-8">The passcode you entered was incorrect.</p>
      <Link to="/login" className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors">
        Try Again
      </Link>
    </div>
  );
};

export default WrongPasscode;